"use client";
import { useState } from "react";
import { Box, Flex, HStack, IconButton } from "@chakra-ui/react";
import { HiChevronLeft, HiChevronRight } from "@onemind-services-llc/react-icons-ng/hi";
import { Carousel } from "@onemind-services-llc/ui-components";
import { useCustomerCarousel } from "@/utils/useCustomerCarousel";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading } from "@/elements";
import BlogCard from "./blogCard";
import { CLIENTS_REVIEW } from "../constants";

const MobileExpertiseContents = ({ filteredReviews }) => {
  const [carouselActions, setCarouselActions] = useState({
    slickPrev: () => {},
    slickNext: () => {},
  });

  const { settings } = useCustomerCarousel({
    dots: false,
    autoplay: false,
    slidesToShow: 1,
  });

  const { slickNext, slickPrev } = carouselActions;
  return (
    <Box>
      <Carousel settings={settings} setSliderRef={setCarouselActions}>
        {filteredReviews.map((item, index) => (
          <BlogCard key={index} {...item} />
        ))}
      </Carousel>
      <HStack gap={"2.5rem"} justifyContent={"center"}>
        <IconButton
          aria-label="previous"
          color="brand.100"
          fontSize="30px"
          onClick={slickPrev}
          variant={"ghost"}
        >
          <HiChevronLeft />
        </IconButton>
        <IconButton
          aria-label="next"
          color="brand.100"
          fontSize="30px"
          onClick={slickNext}
          variant={"ghost"}
        >
          <HiChevronRight />
        </IconButton>
      </HStack>
    </Box>
  );
};

const SuccessStories = ({ excludeSlug }) => {
  const fullExcludeSlug = `/case-studies/${excludeSlug}`;
  const filteredReviews = CLIENTS_REVIEW.CONTENT.filter(
    (review) => review.slug !== fullExcludeSlug
  );
  const HeadingVariant = useHeadingVariant();
  return (
    <Flex id="stories" gap={"2rem"} marginTop={"15px"} direction={"column"}>
      <Heading variant={HeadingVariant} textAlign={{ base: "left", md: "center" }}>
        More stories for you
      </Heading>
      <Box display={{ base: "block", md: "none" }}>
        <MobileExpertiseContents filteredReviews={filteredReviews} />
      </Box>
      <Box
        display={{ base: "none", md: "flex" }}
        gap={"2rem"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        {filteredReviews.map((item, index) => (
          <BlogCard key={index} {...item} />
        ))}
      </Box>
    </Flex>
  );
};

export default SuccessStories;
